import dayjs from 'dayjs';

export function formatDay(time) {
  if (!time) return '';
  return dayjs(time).format('YYYY-MM-DD');
}

export function checkStatus(flag) {
  if (flag === 'T' || +flag === 1) {
    return '已检票';
  } else {
    return '未检票';
  }
}

export function returnStatus(orderDetail) {
  let status = '已退票';

  if (orderDetail.cardNo) {
    if (+orderDetail.returnState === 0) {
      status = '待打款';
    } else if (+orderDetail.returnState === 1) {
      status = '已打款';
    }
  }

  return status;
}

export function getOrderType(flag) {
  if (+flag === 0) {
    return '线下订单';
  } else {
    return '智游宝订单';
  }
}

export function getApiMsg(desc) {
  try {
    const res = JSON.parse(desc);
    if (res.message) {
      return res.message;
    }
    if (res.msg) {
      return res.msg;
    }
    return desc;
  } catch (e) {
    return desc;
  }
}
